import * as React from 'react';
import QRCode from 'react-qr-code';
import './qr.component.scss';
import { buildChargersQrUrl, QrLinkVendor } from '../../services';
type TQRProps = {
	id: string;
	code: string;
	afterRender: (el: HTMLElement | null, code: string) => void;
	forPrint: boolean;
	hiddenTitle: boolean;
	linkVendor: QrLinkVendor;
};

export class QR extends React.Component<TQRProps> {
	componentDidMount() {
		this.afterRender();
	}

	componentDidUpdate(prevProps: Readonly<TQRProps>, prevState: Readonly<{}>, snapshot?: any) {
		this.afterRender();
	}

	afterRender() {
		const { id, afterRender, code } = this.props;
		const element = document.getElementById(`${id}`);
		afterRender(element, code);
	}

	sliceBySpan(code: string) {
		const span = [];
		for (let i = 0; i < code.length; i++) {
			span.push(<span key={i}>{code[i]}</span>);
		}
		return span;
	}

	render() {
		const { forPrint, id, code, hiddenTitle, linkVendor } = this.props;
		const qrValue = buildChargersQrUrl(code, linkVendor);
		return forPrint ? (
			<div className="qr-empty-container" id={id} />
		) : (
			<div className="qr-container-big" id="preview-example" key="qr-container-big">
				{!hiddenTitle && <h3>Взять/Сдать</h3>}
					<div className="qr-media-svg-wrapper">
						<QRCode value={qrValue} size={90} className="qr-media-svg" level="Q" />
					</div>
				<h4>№ {this.sliceBySpan(code).map(span => span)}</h4>
			</div>
		);
	}
}
